(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/team-list-page/assets/javascripts/team-list-page.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/team-list-page/assets/javascripts/team-list-page.js');

'use strict';

const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const {
  CreateTeamButton
} = svs.marketplace.components.common;
const {
  DocumentTitle
} = svs.components.lbUtils;
const {
  Button
} = svs.ui;
const {
  useEffect,
  useRef,
  useCallback
} = React;
const {
  useSelector
} = ReactRedux;
const {
  groupTypeNames
} = svs.components.marketplaceData.constants;
const groupTypeFilter = groupTypeNames.PRIVATE;
const {
  hooks
} = svs.components.marketplace.gameListNew;
const {
  useGetGameUrl
} = hooks;
const {
  getTeamUrl
} = svs.components.marketplace.helpers;
const TeamListPage = () => {
  const dispatch = ReactRedux.useDispatch();
  const history = ReactRouterDOM.useHistory();
  const loadDataRef = useRef(null);
  const intersectionObserver = useRef(null);
  const timeoutId = useRef(null);
  const {
    hasMoreData,
    nextLoading,
    loading,
    data
  } = useSelector(svs.components.marketplaceData.selectors.teams.getCustomerTeamsResult);
  const offset = useSelector(svs.components.marketplaceData.selectors.teams.selectCustomerTeamsOffset);
  const {
    initStates
  } = svs.components.marketplaceData.constants;
  const init = useRef(initStates.WAITING);
  const observerCallback = useCallback(entries => {
    entries.forEach(entry => {
      const isIntersectingLoadDataRef = entry.target === loadDataRef.current && entry.isIntersecting;
      if (isIntersectingLoadDataRef && !nextLoading && hasMoreData) {
        intersectionObserver.current.unobserve(loadDataRef.current);
        dispatch(svs.components.marketplaceData.teams.actions.fetchNextRetailersAndTeamsAction({
          groupTypeFilter,
          offset
        }));
      }
    });
  }, [dispatch, hasMoreData, nextLoading, offset]);
  useEffect(() => {
    intersectionObserver.current = new IntersectionObserver(observerCallback, {
      root: null,
      threshold: [0, 0.5]
    });
    timeoutId.current = setTimeout(() => {
      loadDataRef.current && intersectionObserver.current.observe(loadDataRef.current);
    }, 200);
    return () => {
      if (intersectionObserver.current) {
        intersectionObserver.current.disconnect();
      }
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = null;
      }
    };
  }, [observerCallback, data]);
  useEffect(() => {
    if (init.current === initStates.WAITING) {
      init.current = initStates.ACTIVE;
      const onFetchResults = () => dispatch(svs.components.marketplaceData.teams.actions.fetchNextRetailersAndTeamsAction({
        groupTypeFilter,
        offset
      }));
      if (!(data !== null && data !== void 0 && data.length)) {
        onFetchResults();
      }
    } else if (init.current === initStates.ACTIVE && loading) {
      init.current = initStates.COMPLETE;
    } else if (init.current === initStates.COMPLETE && !loading) {
      init.current = initStates.READY;
    }
  }, [loading, data, dispatch, offset, initStates.ACTIVE, initStates.COMPLETE, initStates.READY, initStates.WAITING]);
  const GameItem = _ref => {
    let {
      game,
      groupId,
      groupName
    } = _ref;
    const gameData = useGetGameUrl(game, {
      groupId,
      groupName,
      isRetail: false,
      isListing: true
    });
    const handleGameClick = () => {
      if (gameData.url) {
        svs.components.Storage.browser.set('lastClickedGame', 'marketplace', {
          activatedDrawId: game.activatedDrawId,
          offset: 0
        });
        history.push(gameData.url);
      }
    };
    return React.createElement(svs.components.marketplace.gameListNew.GameListItem, {
      "aria-label": gameData.ariaLabel,
      key: game.id,
      onClick: handleGameClick
    }, React.createElement(svs.components.marketplace.gameListNew.GameListItemColumns, {
      columnTemplate: "auto 5fr 1fr"
    }, React.createElement(svs.components.marketplace.gameListNew.GameListColumn, {
      className: "team-games-container-column team-games-container-column-logotype"
    }, React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameLogotype, {
      productId: game.productId,
      productName: game.productName
    })), React.createElement(svs.components.marketplace.gameListNew.GameListColumn, {
      className: "team-games-container-column team-games-container-column-info padding-left fc-grey-600"
    }, React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameTitle, {
      className: "fc-navy",
      title: game.name
    }), React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameSoldShares, {
      soldShares: game.soldShares
    }), React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameUserShares, {
      currentUserNumberOfShares: game.currentUserNumberOfShares
    }), React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameBuyStop, {
      buyStop: game.buyStop
    }), React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameStatus, {
      hasPermissionToSubmit: game.isAllowedToSubmit,
      hasPreliminaryRow: game.preliminaryRowExists,
      status: game.status
    })), React.createElement(svs.components.marketplace.gameListNew.GameListColumn, {
      className: "team-games-container-column team-games-container-column-price"
    }, React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameFractionPrice, {
      className: "f-medium",
      fractionPrice: game.fractionPrice
    }), React.createElement(svs.components.marketplace.gameListNew.columnComponents.GameBuyShareButton, {
      activatedDrawId: game.activatedDrawId,
      containerId: game.containerId,
      game: game,
      groupId: groupId
    }))));
  };

  const TeamGames = _ref2 => {
    let {
      teamId
    } = _ref2;
    const games = useSelector(state => svs.components.marketplaceData.selectors.games.selectGames(state, {
      groupId: teamId
    }));
    const {
      role
    } = useSelector(state => svs.components.marketplaceData.selectors.members.selectMe(state, {
      groupId: teamId
    })) || {};
    const hasPermissionToCreateGame = role === 'ADMIN' || role === 'CAPTAIN';
    const gamesList = React.createElement(svs.components.marketplace.gameListNew.GameList, {
      className: "team-games-container"
    }, games.map(game => React.createElement(GameItem, {
      game: game,
      groupId: teamId,
      key: game.id
    })));
    const noGamesMessage = React.createElement("div", {
      className: "empty-state f-center margin-top-1-half no-games-message"
    }, React.createElement("h3", {
      className: "fc-grey-700 margin-left-half"
    }, "Laget har inga \xF6ppna spel just nu"), React.createElement("p", {
      className: "margin-left-half"
    }, "Lagkapten och speladministrat\xF6rer kan \xF6ppna nya spel."));
    const handleCreateGameClick = event => {
      event.preventDefault();
      history.push({
        pathname: getTeamUrl(teamId, 'groupName', 'skapa-spel'),
        state: {
          internalLink: true
        }
      });
    };
    const createGameUrl = getTeamUrl(teamId, 'groupName', 'skapa-spel');
    return React.createElement("div", {
      className: "team-games-container"
    }, React.createElement("div", {
      className: "team-games-content"
    }, (games === null || games === void 0 ? void 0 : games.length) > 0 ? gamesList : noGamesMessage), hasPermissionToCreateGame && React.createElement("div", {
      className: "team-games-footer"
    }, React.createElement(Button, {
      block: true,
      className: "create-game-button qa-create-game-button",
      href: createGameUrl,
      onClick: handleCreateGameClick,
      type: "button"
    }, "Skapa ett nytt spel")));
  };
  return React.createElement(React.Fragment, null, React.createElement(DocumentTitle, {
    title: "Spela i lag - Spela tillsammans | Svenska Spel"
  }), React.createElement("div", {
    className: "marketplace-team-background marketplace-full-width"
  }, React.createElement("div", {
    className: "marketplace-width-limiter"
  }, React.createElement("h2", {
    className: "team-list-header f-medium f-800 margin-0"
  }, "Mina lag"), React.createElement("div", {
    className: "team-list padding-top-1",
    "data-testid": "qa-mkp-customer-teamlist"
  }, React.createElement(svs.components.marketplace.teamList.TeamList, {
    maxGamesToDisplay: 3,
    shouldUseLastClicked: true,
    teamClassName: "team-listing margin-1"
  }, team => React.createElement(TeamGames, {
    teamId: team.id
  })), React.createElement(CreateTeamButton, {
    className: "team-container margin-1"
  })), React.createElement("div", {
    className: "qa-fetch-more-data",
    ref: loadDataRef
  }, React.createElement("div", {
    className: "align-center"
  }, React.createElement("div", {
    className: "padding-1"
  }, hasMoreData && !loading ? 'Visar mer...' : '')))), React.createElement("div", {
    className: "marketplace-content-wrapper"
  }, React.createElement(WidgetArea, {
    className: "marketplace-teams-widget-area",
    widgetArea: "teamsWidgetArea"
  }))));
};
setGlobal('svs.marketplace.components.teamListPage.TeamListPage', TeamListPage);

 })(window);